import Vue from 'vue'

export default {
    get(id) {
        return Vue.axios.get(`/products/${id}`)
    },
    list(params) {
        params.fromAdmin = true
        return Vue.axios.get(`/products`, {params})
    },
    massEdit(act, params){
        return Vue.axios.post(`/products/mass-edit/${act}`, params)
    },
    updateSort(data) {
        return Vue.axios.post(`/products/sort/update`, data)
    },
    remove(id){
        return Vue.axios.get(`/products/remove/${id}`)
    },
    copy(productId) {
        return Vue.axios.post(`/products/copy`, {productId})
    },
    updateModifierRelation(productId, itemId, params){
        return Vue.axios.post(`/products/update/${productId}/modifiers/${itemId}`, params)
    },
    updateProductModifiersSort(id, data){
        return Vue.axios.post(`/products/${id}/modifiers/sort/update`, data)
    },
    sauces(params) {
        return Vue.axios.get(`/products/get-sauces`, {params})
    },
    update(id, data) {
            return Vue.axios.post(`/products/update/${id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
    },
    findByName(params){
        return Vue.axios.get(`/products/find-by-name`, {params})
    },
    create(data) {
        return Vue.axios.post(`/products/create`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    updatePopularProducts(data) {
        return Vue.axios.post(`/products/popular/update`, data)
    },
    updatePopularProductsSort(data) {
        return Vue.axios.post(`/products/popular/sort/update`, data)
    },
    getPopularRelation(params) {
        return Vue.axios.get(`/products/popular/relation`, {params})
    },
    listByCategory(params) {
        return Vue.axios.get(`/products-by-category`, {params})
    },
    updateModifiers(id, data) {
        return Vue.axios.post(`/products/update/${id}/modifiers`, data)
    },
    updateModifiersGroup(id, data) {
        return Vue.axios.post(`/products/update/${id}/modifiers-group`, data)
    },
    removeModifierRelation(id){
        return Vue.axios.get(`/products/remove/modifier/${id}`)
    }
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
